import { render } from "./ChildMenuItem.vue?vue&type=template&id=33871f50"
import script from "./ChildMenuItem.vue?vue&type=script&lang=js"
export * from "./ChildMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__